import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  Renderer,
  ComponentFactory,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  EventEmitter,
  Output
} from "@angular/core";
import { LookupConfiguration } from "../lookup/lookup.config";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import {
  FiDimensionbaseComponent,
  DimensionValue
} from "./fidimension/fidimensionbase.component";
import { BaseComponent } from "../../core/component/Base.Component";

@Component({
  moduleId: module.id,
  selector: "ixs-fidimension",
  templateUrl: "ixs-fidimension.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IXSFIDimensionComponent),
      multi: true
    }
  ]
})
export class IXSFIDimensionComponent extends BaseComponent
  implements ControlValueAccessor {
  @ViewChild("dimensionbaseviewer") public dimensionViewer: ModalComponent;
  @ViewChild("dimensionbase", { read: ViewContainerRef }) container;

  @Output()
  afterDimenstionSelected: EventEmitter<
    Array<DimensionValue>
  > = new EventEmitter<Array<DimensionValue>>();

  @Output()
  onOpenDimenstion: EventEmitter<Array<DimensionValue>> = new EventEmitter<
    Array<DimensionValue>
  >();

  componentRef: any;
  constructor(
    private element: ElementRef,
    private renderer: Renderer,
    private resolver: ComponentFactoryResolver
  ) {
    super();
  }

  //for the purpose of fire event on lister select event
  public triggerChanged() {
    let event = new CustomEvent("change", { bubbles: true });
    this.renderer.invokeElementMethod(
      this.element.nativeElement,
      "dispatchEvent",
      [event]
    );
  }

  private innerValue: any = "";

  private onTouchedCallback: () => void;
  private onChangeCallback: (_: any) => void;

  @Input()
  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  // @ViewChild("lookup") public lookup: LookupComponent;

  @Input()
  config: LookupConfiguration[];

  @Input()
  valueMember: string;

  @Input()
  displayMember: string;

  @Input()
  caption: string;

  @Input()
  lookupCaption: string;

  @Input()
  fieldName: string;

  _data: any[];
  get data(): any[] {
    return this._data;
  }

  @Input()
  set data(value: any[]) {
    this._data = value;
  }

  @Input()
  disabled: boolean = false;

  @Input()
  showCaption: boolean = true;

  async Modelchange() {
    this.value = Number(this.value);
  }
  ondelete(event) {
    this.value = "";
  }
  @Input()
  position: number = 1;

  @Input()
  showNone: boolean = false;

  _defaultValues: Array<DimensionValue>;
  get Values(): Array<DimensionValue> {
    return this.componentRef.instance.Values;
  }
  @Input()
  set Values(value: Array<DimensionValue>) {
    this._defaultValues = value;
  }

  get title() {
    return this.caption.replace("*", "");
  }

  public async openDimension() {
    
    if (this.value) {
      this.onOpenDimenstion.emit();
      this.container.clear();
      const factory: ComponentFactory<
        any
      > = this.resolver.resolveComponentFactory(FiDimensionbaseComponent);
      this.componentRef = this.container.createComponent(factory);
      this.componentRef.instance.Values = this._defaultValues;
      this.componentRef.instance.getDimension(this.value);
      this.componentRef.instance.afterDimenstionSelected.subscribe(o => {
        this.afterDimenstionSelected.emit(o);
        this.dimensionViewer.close();
      });
      await this.dimensionViewer.open("sm");
    } else {
      this.showErrors(
        "please select " + this.caption.replace("*", "") + " first"
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ixs-fidimension/ixs-fidimension.component.ts